import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { LoadingButton } from '@mui/lab';
import Grid from '@mui/material/Grid';
import React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import { GREEN_COLOR } from '../../../../constants/ColorsConst';
import { useNotification } from '../../../../helpers/Notification';
import { ADMIN_CONST, ROOT_CONST } from '../../../auth/login/LoginReducer';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import {
  USU_ENTIDADES_CONST,
  uploadFilesAction,
} from '../../../files/FilesAction';
import { USUARIOS_CONST } from '../UsuariosService';

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const SettingsUsuariosComponent = ({
  setModalCarnets = () => {},
  setDrawer = () => {},
  idEntidad,
  tipo,
  params,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);

  const [loading, setLoading] = React.useState(false);
  const [namefile, setNamefile] = React.useState(null);

  const upaloadFile = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      console.log('No file selected.');
      return;
    }
    setNamefile(file.name);

    setLoading(true);
    await uploadFilesAction(
      { dispatch, notify },
      tipo,
      { file, tipo: USU_ENTIDADES_CONST ? USUARIOS_CONST : tipo, idEntidad },
      params,
    );
    setDrawer(false);
    setLoading(false);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} ms={12}>
        {[ROOT_CONST, ADMIN_CONST].includes(loginStore.rol) && (
          <LoadingButton
            fullWidth
            loading={loading}
            sx={{
              backgroundColor: GREEN_COLOR,
            }}
            component="label"
            size="large"
            variant="contained"
            onChange={upaloadFile}
            startIcon={<CloudUploadIcon />}
          >
            {loading
              ? 'Subiendo Excel...'
              : namefile ?? 'Subir documento Excel'}
            <VisuallyHiddenInput type="file" accept=".xlsx, .xls" />
          </LoadingButton>
        )}
      </Grid>
      {loginStore.isRoot && (
        <Grid item xs={12} md={12}>
          <BotonComponent
            fullWidth
            size="large"
            click={async () => {
              setModalCarnets(true);
            }}
            blue
            mr={2}
            downloadIcon
            text="Procesar Carnet"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default SettingsUsuariosComponent;
